import { Controller } from '@hotwired/stimulus'

export default class CountProgressController extends Controller {
  static targets = ['circle', 'counter']

  update(event) {
    const { length, max = 280 } = event.detail
    const inputLength = Math.min(length, max)
    const dashOffset = 100 - (inputLength / max) * 100
    if (this.hasCircleTarget) {
      this.circleTarget.style.strokeDashoffset = dashOffset
    }
  }

  updateCount(event) {
    if (!this.hasCounterTarget) return;

    const currentLength = event.target.value.length
    this.counterTarget.textContent = currentLength
  }
}